import { talentIndex70, talentIndex80, talentIndex90 } from 'data/colors';

const talentIndexCellStyle = [
  {
    when: (row) => row.attributes.talent_index_group === 'risk',
    style: {
      backgroundColor: talentIndex70,
    },
  },
  {
    when: (row) => row.attributes.talent_index_group === 'core',
    style: {
      backgroundColor: talentIndex80,
    },
  },
  {
    when: (row) => row.attributes.talent_index_group === 'high',
    style: {
      backgroundColor: talentIndex90,
    },
  },
];

const columns = (teams) => [
  {
    name: 'Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
    exportable: true,
  },
  {
    name: 'Work Email',
    selector: (row) => row.attributes.email,
    sortable: true,
    searchable: true,
    exportable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
    filter: {
      type: 'MULTI_SELECT',
      options: teams ? teams.map((item) => item.attributes.title) : [],
    },
    exportable: true,
  },
  {
    name: 'Invited On',
    selector: (row) => row.attributes.invited_on_timestamp,
    format: (row) => row.attributes.invited_on_formatted,
    sortable: true,
    exportable: true,
  },
  {
    id: 'talent_index',
    name: 'Talent Index',
    selector: (row) => row.attributes.coaching_readiness_score,
    sortable: true,
    conditionalCellStyles: talentIndexCellStyle,
    format: (row) => (row.attributes.coaching_readiness_score ? row.attributes.coaching_readiness_score : 'N/A'),
    exportable: true,
  },
  {
    name: 'Talent Ranking',
    selector: (row) => row.attributes.talent_index_group,
    exportable: true,
    omit: true,
    filter: {
      type: 'SINGLE_SELECT',
      options: [
        { label: 'Hight Potential', value: 'high' },
        { label: 'Core', value: 'core' },
        { label: 'At Risk', value: 'risk' },
        { label: 'N/A', value: 'na' },
      ],
    },
  },
];

export default columns;
